module.exports = __webpack_public_path__ + "static/media/the_fight_for_food_security_mobile.898c1ce9.jpg";